<template>
  <div>
    <h1>Welcome to use DP-GUI</h1>
  </div>
</template>
